import React from 'react';

const TableWidget = ({ data }) => {
  const { summary, columns = [], rows = [] } = data || {};

  if (!columns.length || !rows.length) {
    return (
      <div className="table-widget-empty">
        {summary || 'Sin datos para mostrar en la tabla.'}
      </div>
    );
  }

  return (
    <div className="table-widget-body">
      {summary && <p className="table-widget-summary">{summary}</p>}
      <div className="table-widget-scroll">
        <table className="table-widget-table">
          <thead>
            <tr>
              {columns.map((col, idx) => (
                <th key={idx}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, ridx) => (
              <tr key={ridx}>
                {(Array.isArray(row) ? row : columns.map(c => row?.[c])).map((cell, cidx) => (
                  <td key={cidx}>
                    {cell === null || cell === undefined ? '—' : String(cell)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableWidget;
